import React from "react";
import AddDeductTaxRow from "./AddDeductTaxRow";

/**
 * A single EE & ER Taxes row.
 * Thin memoized wrapper around the shared AddDeductTaxRow component.
 *
 * Props (3 grouped objects):
 *   rowData  — { row, index, isRemoving, touchedRow, errorRow }
 *   ctx      — { showItemColumn, isReadOnly, formValuesDepartment, formValuesJob,
 *                mappedToOptionsMap, mappedToLookup, accountOptionsMap, accountOptions }
 *   handlers — { setFieldValue, enqueueSnackbar, fetchCoaDetails, onAddNewMappedItem,
 *                remove, setRemovingIndex, showDeleteConfirm, setOpenAddCOA, setPendingCOAField }
 */
const TaxRow = React.memo(function TaxRow(props) {
    const isGrouped = Boolean(props.rowData);
    const ctx = isGrouped ? { ...props.ctx, isTax: true } : undefined;

    return isGrouped ? (
        <AddDeductTaxRow rowData={props.rowData} ctx={ctx} handlers={props.handlers} />
    ) : (
        <AddDeductTaxRow {...props} isTax={true} />
    );
});

export default TaxRow;
